import { render } from "./App.vue?vue&type=template&id=2e9d3922&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2e9d3922&lang=scss"

import exportComponent from "/builds/enrian/design/design-system-documentation/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__